export default __webpack_public_path__ + "static/media/yo_6.6d52a677.mp3";